export const formatPrice = (price?: number, currency = 'EUR') =>
  price != null ? new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(price) : '';
